var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._b({attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},'svg',_vm.$attrs,false),[_c('path',{attrs:{"d":"M15.8346 7.5L10.0013 12.5L4.16797 7.5","stroke":"#FFFFFFD9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }